import * as Sentry from '@sentry/react';

const { ErrorBoundary, showReportDialog, setTag } = Sentry;

export type { ErrorBoundaryProps } from '@sentry/react';

export { ErrorBoundary, showReportDialog, setTag };

export * from './sentry';
export * from './tags';
